import { ReactElement } from 'react'
import { defaultTheme } from '../../../../../../src/theme/index'
import { zIndex } from '../../../../../../src/theme/zIndex'
import styled from 'styled-components'

interface Props {
  title: string
  message?: ReactElement
  icon: ReactElement
  visible: boolean
}

const FloatingMessage = (props: Props): ReactElement => {
  const { title, message, icon, visible } = props

  if (!visible) return null

  return (
    <Wrapper>
      <IconWrapper>
        <div>{icon}</div>
      </IconWrapper>
      <div>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  min-width: 295px;
  padding: 12px 16px 12px 16px;
  border-radius: 8px;
  margin: 24px;
  position: fixed;
  bottom: 80px;
  gap: 16px;
  z-index: ${zIndex.toastNotification};
  background-color: ${defaultTheme.colors.floatingMessage};
  box-shadow: 0px 0px 1px 1px ${defaultTheme.colors.greyVeryLight};
`

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  text-transform: capitalize;
`

const Message = styled.div`
  font-size: 16px;
`

const IconWrapper = styled.div`
  display: flex;
  align-content: center;
  flex-wrap: wrap;
`

export default FloatingMessage
